import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@material-tailwind/react";
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

export function Paginate({ listproductLength, handlePage }) {
    const { page, totalPages } = listproductLength;
    const [active, setActive] = useState(page || 1);

    const getItemProps = (index) => ({
        variant: active === index ? "filled" : "text",
        color: "gray",
        onClick: () => setActive(index),
    });

    const next = () => {
        if (active < totalPages) {
            setActive(active + 1);
        }
    };

    const prev = () => {
        if (active > 1) {
            setActive(active - 1);
        }
    };

    // Only call handlePage when active page changes
    useEffect(() => {
        handlePage(active);
    }, [active, handlePage]);

    return (
        <>
            {totalPages > 1 && (

                <div className="flex justify-center items-center gap-2 my-5 ">
                    <Button
                        variant="text"
                        className="flex items-center gap-2 bg-white"
                        onClick={prev}
                        disabled={active === 1}
                    >
                        <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" /> Previous
                    </Button>
                    <div className="flex items-center gap-2 rounded-md bg-white">
                        {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNum) => (
                            <IconButton key={pageNum} {...getItemProps(pageNum)}>
                                {pageNum}
                            </IconButton>
                        ))}
                    </div>
                    <Button
                        variant="text"
                        className="flex items-center gap-2 bg-white"
                        onClick={next}
                        disabled={active === totalPages}
                    >
                        Next
                        <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
                    </Button>
                </div>
            )}
        </>
    );
}
